import { ArrowLeftRight } from "lucide-react";

import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

interface ChangeIndicatorBadgeProps {
  className?: string;
}

/**
 * Compact compare-mode marker for tabs and field labels that changed between versions.
 */
export function ChangeIndicatorBadge({ className }: ChangeIndicatorBadgeProps) {
  return (
    <Tooltip>
      <TooltipTrigger render={<span />}>
        <span
          role="img"
          aria-label="Changed in comparison"
          className={cn(
            "inline-flex size-4 items-center justify-center rounded-none border border-blue-border bg-surface-blue text-blue-content",
            className
          )}
        >
          <ArrowLeftRight className="size-2.5" />
        </span>
      </TooltipTrigger>
      <TooltipContent side="bottom">Changed in comparison</TooltipContent>
    </Tooltip>
  );
}
